import React from 'react';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Filler,
    Tooltip,
    Legend,
} from 'chart.js';
import { Line } from 'react-chartjs-2';

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Filler, Tooltip, Legend);

interface MockTrendChartProps {
    variant?: 'full' | 'compact';
    className?: string;
}

const LABELS = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];

const MOCK_DATA = {
    labels: LABELS,
    datasets: [
        {
            label: 'HRV',
            data: [62, 58, 65, 71, 68, 72, 75, 70, 74, 78, 76, 80, 82, 79],
            borderColor: '#3B82F6',
            backgroundColor: 'rgba(59, 130, 246, 0.08)',
            fill: true,
            tension: 0.3,
            pointRadius: 2,
            pointBackgroundColor: '#3B82F6',
            borderWidth: 2,
        },
        {
            label: 'Recovery',
            data: [70, 65, 72, 68, 75, 78, 80, 76, 82, 79, 85, 83, 88, 86],
            borderColor: '#059669',
            backgroundColor: 'rgba(5, 150, 105, 0.08)',
            fill: true,
            tension: 0.3,
            pointRadius: 2,
            pointBackgroundColor: '#059669',
            borderWidth: 2,
        },
    ],
};

const getOptions = (compact: boolean) => ({
    responsive: true,
    maintainAspectRatio: false,
    scales: {
        x: {
            grid: { color: 'rgba(255,255,255,0.04)' },
            ticks: {
                color: 'rgba(255,255,255,0.3)',
                font: { size: compact ? 8 : 10, family: 'Inter, sans-serif' },
                maxTicksLimit: compact ? 5 : 7,
            },
            border: { color: 'rgba(255,255,255,0.08)' },
        },
        y: {
            grid: { color: 'rgba(255,255,255,0.04)' },
            ticks: {
                color: 'rgba(255,255,255,0.3)',
                font: { size: compact ? 8 : 10, family: 'Inter, sans-serif' },
                maxTicksLimit: 5,
            },
            border: { color: 'rgba(255,255,255,0.08)' },
            suggestedMin: 40,
            suggestedMax: 100,
        },
    },
    plugins: {
        legend: { display: false },
        tooltip: { enabled: false },
    },
    events: [] as const,
});

const MockTrendChart: React.FC<MockTrendChartProps> = ({ variant = 'full', className = '' }) => {
    const compact = variant === 'compact';
    const height = compact ? 160 : 200;

    return (
        <div className={`relative ${className}`} style={{ height }}>
            <Line data={MOCK_DATA} options={getOptions(compact)} />
        </div>
    );
};

export default MockTrendChart;
